module.exports = __webpack_public_path__ + "img/w50.090bbd42.svg";